/**
* 模版
**/

<template>
    <div style="width: 1200px; margin: auto">
        <div class="welcometop">
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="welcometop_left">
                        <h3>欢迎来到爱锋派商城系统</h3>
                        <p>若您还没有填写入驻申请资料,<br/>
                            请点击“我要入驻”进行入驻资料填写<br/>
                            若您的店铺资料已经填写<br/>
                            请点击“店铺详情”进行详细的资料填写<br/>
                        </p>

                         <el-button size="small" @click="$router.push('/merchantTypeSelect')">我要入驻</el-button>
                        <el-button size="small" v-if="userInfo.type==1"><a :href="$baseUrl" target="_blank">店铺详情</a></el-button>
                      <el-button v-if="dealerSettledStatus" size="small" @click="settled">申请经销商</el-button>
                    </div>
                </el-col>
                <el-col :span="16">
                    <div class="welcometop_right">
                        <el-image :src="logoimg==''?'':logoimg"></el-image>
                        <!-- <el-image :src="require('@/assets/img/bigbackground.png')"></el-image> -->
                        <!-- ceshi.xunyoutest.com/account/static/src/default/images/login-slide.png -->
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="welcomeTabs" v-loading="loading">
            <el-tabs type="border-card">
                <el-tab-pane :label="item.title" v-for="(item,index) in agreementThreelists" :key="index">
                    <p v-html="item.content"></p>
                </el-tab-pane>
                <!-- <el-tab-pane label="招商规则1">
                    招商规则2
                </el-tab-pane>
                <el-tab-pane label="招商规则2">
                    招商规则3
                </el-tab-pane> -->
            </el-tabs>
        </div>
    </div>
</template>

<script>
// // 导入组件
import {agreementThreelist,pageConfigImg } from "@/api/xunyou";
import { queryDealerSettledStatus, getMercharntStatus } from "@/api/dealerSettled";
import {mapState} from 'vuex'
// 导出模块
export default {
  // 模块名字
  name: "",
  // 模块数据
  data() {
    //数据
    return {
        dealerSettledStatus:false,
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        loading:false,
        agreementThreelists:[],
        logoimg:'',
    };
  },
  // 注册组件
  components: {
    // headerComponent
  },
  computed:{
    ...mapState(['user'])
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  created() {
    this.queryDealerSettledStatus()
  },
  mounted(){
      this.getagreementThreelist()
      this.getpageConfigImg()
  },
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    //   获取图片
    getpageConfigImg() {
      pageConfigImg()
        .then((res) => {
          if (res.code == 0) {
            this.logoimg = res.rows[0].configValue
            if(this.logoimg==''){
                this.logoimg=require('@/assets/img/bigbackground.png');
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("查询图片，请稍后再试！");
        });
    },
    // agreementThreelist
    // tab列表查询
    getagreementThreelist() {
      console.log("tab列表查询");
      this.loading = true;
      agreementThreelist({
        type: 1 // 1:店铺；2.会员；3：供应商
      })
        .then((res) => {
          //   if (res.code == 0) {
          console.log("res", res);
          this.loading = false;
          this.agreementThreelists = res.data

        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询招商规则失败，请稍后再试！");
        });
    },
    queryDealerSettledStatus() {
      queryDealerSettledStatus({}).then(res => {
        if (res.data.configValue == '1') {
          this.dealerSettledStatus = true
        } else {
          console.log('系统未开放申请经销商功能')
        }
      })
    },
    settled() {
      let that = this;
      let obj = {};
      obj.type = 3
      obj.username = that.userInfo.loginName
      getMercharntStatus(obj).then(res => {
        if (res.code == 0) {
          if (res.data.status == 5) {
            that.$router.push('/dealerSettled')
          } else if (res.data.status >= 1 && res.data.status <= 3) {
            that.$router.push('/dealerStatus')
          }
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  }
}
</script>
<style scoped lang='less'>
.welcometop {
    background-color: #ffffff;
	/* background-color: rgb(241, 165, 149); */
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 25px;
    box-sizing: border-box;
    .welcometop_left {
        padding: 10px 25px;
        background-color: rgba(0,0,0,0.2);
        color: #fff;
        h3{
            font-size: 18px;
        }
        p{
            line-height: 24px;
            margin: 10px 0;
        }
        /deep/.el-button:focus, .el-button:hover {
            color: #78b942;
            border-color: #78b942;
        }
    }
    .welcometop_right{
        .el-image{
            height: 195px;
        }
    }
}
.welcomeTabs{
        /deep/.el-tabs--border-card {
            border: none !important;
            box-shadow:none !important;
        }
        /deep/.el-tabs--border-card>.el-tabs__header {
            background-color:#f7f8f8 !important;
            border-bottom: none !important
        }

    }

</style>



// WEBPACK FOOTER //
// src/views/merchantSettled/welcomesystem.vue